import {ColDef} from 'ag-grid-community';
import {useMemo} from 'react';
import {FiltersData, RowDef} from './types';
import {EntitiesFilter} from '@esgi/ui/ag-grid';
import {getStudentsTableColumnDef} from '@esgi/main/kits/admin';
import {useUser} from '@esgi/core/authentication';

export function useColumnDefinitions(filtersData: FiltersData) {
	const currentUser = useUser();

	return useMemo<ColDef<RowDef>[]>(
		() => [
			getStudentsTableColumnDef.firstName({
				currentUser,
				lockVisible: true,
				headerComponentParams: {
					description: 'Displays the first name of a student (Required)',
				},
			}),
			getStudentsTableColumnDef.lastName({
				currentUser,
				lockVisible: true,
				headerComponentParams: {
					description: 'Displays the last name of a student (Required)',
				},
			}),
			{
				field: 'teacher',
				headerName: 'Teacher',
				filter: EntitiesFilter,
				filterParams: {
					entities: filtersData.availableTeachers,
				},
				headerComponentParams: {
					description: 'Displays the name of a teacher to whom a student is assigned',
				},
				sortable: true,
			},
			{
				field: 'class',
				headerName: 'Class',
				filter: EntitiesFilter,
				filterParams: {
					entities: filtersData.availableClasses,
				},
				headerComponentParams: {
					description: 'Displays the name of any classes to which a student is assigned',
				},
				sortable: true,
			},
			{
				headerName: 'Groups',
				field: 'group',
				filter: EntitiesFilter,
				filterParams: {
					entities: filtersData.availableGroups,
				},
				headerComponentParams: {
					description: 'Displays the name of any groups to which a student is assigned',
				},
				sortable: true,
			},
			{
				headerName: 'Specialists',
				field: 'specialist',
				filter: EntitiesFilter,
				filterParams: {
					entities: filtersData.availableSpecialists,
				},
				headerComponentParams: {
					description: 'Displays the specialists names.',
				},
				sortable: true,
			},
			{
				headerName: 'Specialist Groups',
				field: 'specialistGroups',
				filter: EntitiesFilter,
				filterParams: {
					entities: filtersData.availableSpecialistGroups,
				},
				headerComponentParams: {
					description: 'Displays the specialist groups names.',
				},
				sortable: true,
			},
		],
		[currentUser, filtersData],
	);
}
